<template>
    <div>
    <h1>RegisterPage</h1>
    <section id="register-form" class="wrapper vh-200" >
    <div class="container d-flex justify-content-center align-items-center h-100">
        <div  class="col-12" >
            <form action="" method="post" @submit.prevent = "registerUser"> 
              <div>
                <div class="form-group">
                  <label for="">Input Your Username:</label> <br>
                  <input v-model = "username" class="form-control" type="text" name="username" id="register-user" placeholder="username.." required> <br>
                </div>
                <div class="form-group">
                  <label for="">Input Your Email:</label><br>
                  <input v-model = "email" class="form-control" type="email" name="email" id="register-email" placeholder="email.." required> <br>
                </div>
                <div class="form-group">
                  <label for="">Input Password:</label> <br>
                  <input v-model = "password" class="form-control" type="password" name="password" id="register-password" placeholder="password.." required> <br>
                </div>
                <div class="form-group">
                  <label for="">Input Your Phone Number</label><br>
                  <input v-model = "phoneNumber" class="form-control" type="text" name="phoneNumber" id="register-phoneNumber" placeholder="0819---" required> <br>
                </div>
                <div class="form-group">
                  <label for="">Input Your Adress</label> <br>
                  <input v-model = "address" class="form-control" type="text" name="address" id="register-address" placeholder="Bandung St.." required> 
                </div>
              </div>
              <button class="btn btn-primary ml-2"  type="submit" value="Register"
              
              >
                  <!-- <span v-if= "loading">Wait for register</span>
                  <span v-if = '!loading'> -->
                      Register
                  <!-- </span> -->
              </button>
              <input @click.prevent = "cancel" class="btn btn-secondary ml-2"  type="submit" value="Cancel"> 
            </form>
        </div>
    </div>
  </section>

    </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
    name : "RegisterPage",
    data : function(){
      return {
        username : '',
        email : '',
        password: '',
        phoneNumber : '',
        address : ''
      }
    },
    methods : {
      cancel(){
        this.$router.push({name : "LoginPage"})

      },
      registerUser(){
        let user = {
          username : this.username,
          email : this.email,
          password : this.password,
          phoneNumber : this.phoneNumber,
          address : this.address
        }
        this.$store.commit("REGISTER_USER", user)
        this.$store.dispatch("registerUser")
          .then(response => {
            console.log(response);
            this.$router.push({name : "LoginPage"})
          })
          .catch(err => {
            Swal.fire(err.response.data.message)
            
          })
      }
    }
}
</script>

<style>

</style>